import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { checkEsse3UserNewEnrollments, fetchGetExams, fetchGetPendingExams, fetchGetUserExams } from "./ExamsApi"
import { toast } from 'react-toastify';
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { Text } from "../../components/Text";
import { TitleH3 } from "../../components/TitleH3";
import { TitleH2 } from "../../components/TitleH2";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import img_user from './assets/images/user.svg'
import img_users from './assets/images/users.svg'
import img_arrow from './assets/images/right.svg'
import structure_img from './assets/images/structure.svg'
import img_clock from './assets/images/clock_green.svg'
import timer_img from './assets/images/timer.svg'
import score_img from './assets/images/score.svg'
import details_img from './assets/images/details.svg'
import rank_img from './assets/images/rank.svg'
import exam_img from '../../components/Navigation/icons/verifica.svg'
import hands_img from '../../assets/images/high-five-hand.svg'
import history_img from '../../assets/images/history.svg'
import question_img from '../../assets/images/ofa/question.svg'
import info_img from '../../assets/images/info-white.svg'
import point_img from '../../assets/images/score.svg'

import { Link, useNavigate } from "react-router-dom";
import { selectAppInfo } from "../../services/utils/appInfoSlice";
import { selectUserData } from "../../features/User/userSlice";
import { Button } from "../../components/Button";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import ExamResultsModal from "./_components/ExamResultsModal";
import { showError } from "../../features/Error/errorSlice";
import { formatScore } from "./examUtils";

export default function ExamsList (props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [examsData, setExamsData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [hasMore, setHasMore] = useState(false)
    const [fetchState, setFetchState] = useState(
       { start_cursor: null, limit: 10}
    )

    //OFA-ONLY
    const [showExamBanner, setShowExamBanner] = useState(false)
    const [showContactBanner, setShowContactBanner] = useState(false)
    const [hasPassedExams, setHasPassedExams] = useState(false)
    const [showEsse3Banner, setShowEsse3Banner] = useState(false)
    const [historyExams, setHistoryExams] = useState(null)

    const [resultsModalData, setResultsModalData] = useState(null)

    const appInfo = useSelector(selectAppInfo)
    const userInfo = useSelector(selectUserData)

    const loadPendingUserExams = async () => {
        const _params = {
            ...(fetchState.limit && {limit: fetchState.limit} ),
            ...(fetchState?.start_cursor && {start_cursor: fetchState.start_cursor})
        }
        let response = await fetchGetPendingExams(_params)
        if(response.success){
            // this list is only ever rendered for the general tab (showPending is never
            // true for the customizable tab), so customizable exams only belong in their own tab
            let _temp_exams = (response.data?.user_exams || []).filter(e => !e.is_customizable)
            _temp_exams = _temp_exams.map((e) => {return {...e, is_started: true}})
            response = await fetchGetExams(_params)
            if(!response.success){
                toast.error(t.exams.errors.loading)
                return;
            }
            const _new_exams = (response?.data?.exams || []).filter(e => !e.is_customizable)
            setExamsData([..._temp_exams, ..._new_exams])
            setFetchState({...fetchState, start_cursor: response?.data?.next_cursor})
            setHasMore(!!response?.data?.next_cursor && _new_exams.length === fetchState.limit)
            setIsLoading(false)
        } else {
            console.error(response.error)
        }
    }

    const loadExams = async (reset = false) =>{
        const _params = {
            ...(fetchState.limit && {limit: fetchState.limit} ),
            ...(fetchState?.start_cursor && {start_cursor: fetchState.start_cursor}),
            has_started: props.showStarted,
            ...(props.onlyCustom && {only_custom: true})
        }
        const response = await fetchGetExams(_params)
        if(response.success){
            // the general tab (onlyCustom falsy) must not surface customizable exams:
            // those only belong in the dedicated customizable tab
            const _new_exams = (response?.data?.exams || []).filter(e => props.onlyCustom || !e.is_customizable)
            setExamsData(reset ? _new_exams : [...examsData, ..._new_exams])
            setFetchState({...fetchState, start_cursor: response?.data?.next_cursor})
            setHasMore(!!response?.data?.next_cursor && _new_exams.length === fetchState.limit)
            setIsLoading(false)
        } else {
            toast.error(t.exams.errors.loading)
        }
    }

    const loadHistoryExams = async (reset = false) =>{
        const _params = {
            ...(fetchState.limit && {limit: fetchState.limit} ),
            ...(!reset && fetchState?.start_cursor && {start_cursor: fetchState.start_cursor}),
            has_started: props.showStarted
        }
        const response = await fetchGetUserExams(_params)
        if(response.success){
            const _new_exams = response?.data?.user_exams || []
            setExamsData(reset ? _new_exams : [...examsData, ..._new_exams])
            setFetchState({...fetchState, start_cursor: response?.data?.next_cursor})
            setHasMore(!!response?.data?.next_cursor && _new_exams.length === fetchState.limit)
            setIsLoading(false)
        } else {
            toast.error(t.exams.errors.loading)
        }
    }

    const loadMore = async () => {
        if(isLoadingMore) return
        setIsLoadingMore(true)
        if(props.showHistory)
            await loadHistoryExams(false)
        else
            await loadExams(false)
        setIsLoadingMore(false)
    }

    const checkHistoryExams = async () =>{
        const _params = {
            has_started: true
        }
        const response = await fetchGetUserExams(_params)
        if(response.success){
            setHistoryExams(response.data?.user_exams)
        } else {
            console.error(response.error)
        }   
    }

    const checkEsse3Tests = async () => {
        const response = await checkEsse3UserNewEnrollments()
        if(response.success){
            if(response.data?.groups_id?.length > 0){
                toast.success(t.ofa.esse3.test_found)
                loadExams(true)
            } else {
                dispatch(showError({title: t.ofa.esse3.no_test_available, text: t.ofa.esse3.no_test_available_text}))
            }
        } else {
            toast.error(t.ofa.esse3.tech_error)
        }  
    }

    const checkOfaUserGroups = async () => {
        if(appInfo.is_ofa){
            let show_exam_banner = false
            let show_contact_banner = false
            const user_groups = userInfo?.groups || []
            let count_passed = 0
            let count_ofa = 0
            if(appInfo?.personalizations?.ofa_settings?.esse3_integration_enabled){
                if( user_groups?.length > 0
                    && appInfo?.is_ofa
                ){
                    setShowEsse3Banner(true)
                } else if (appInfo?.personalizations?.tenant_settings?.is_self_assessment){
                    setShowExamBanner(false)
                }
            } else {
                appInfo?.personalizations?.ofa_settings?.group_settings?.forEach((ofa_group)=>{
                if (user_groups?.includes(ofa_group?.group_id)){
                    count_ofa += 1
                    //if user has ofa group check if it has completed group
                    if(user_groups?.includes(ofa_group?.video_completion_group_id)){
                        //if the user has the first test group check if it has also the retry group and if yes load exams if not altready did
                        if(user_groups?.includes(ofa_group?.retry_exam_group_id) ){
                            if (historyExams && !historyExams?.find(e => e.allowed_groups?.includes(ofa_group?.retry_exam_group_id) && e.end_date))
                                show_exam_banner = true
                            else if( historyExams && historyExams?.find(e => e.end_date 
                                && e.allowed_groups?.includes(ofa_group?.retry_exam_group_id) 
                                && !e?.thresholds?.find(t => t.threshold_type==="certificate_generation")?.has_been_passed))
                                show_contact_banner = true
                            else if(historyExams && historyExams?.find(e => e.end_date 
                                && e.allowed_groups?.includes(ofa_group?.retry_exam_group_id) 
                                && e?.thresholds?.find(t => t.threshold_type==="certificate_generation")?.has_been_passed))
                                count_passed += 1
                        } else {
                            //else we show the banner
                            if( historyExams && historyExams?.find(e => e.end_date 
                                && e.allowed_groups?.includes(ofa_group?.video_completion_group_id) 
                                && !e?.thresholds?.find(t => t.threshold_type==="certificate_generation")?.has_been_passed))
                                show_contact_banner = true
                            else if(historyExams && historyExams?.find(e => e.end_date 
                                && e.allowed_groups?.includes(ofa_group?.video_completion_group_id) 
                                && e?.thresholds?.find(t => t.threshold_type==="certificate_generation")?.has_been_passed))
                                count_passed += 1
                        }
                    } // if it hasn't completed the group we show waiting message
                    else {
                        show_exam_banner = true
                    }
                }
            })
            if(count_passed === count_ofa)
                setHasPassedExams(true)
            if(show_exam_banner)
                setShowExamBanner(true)
            else if(show_contact_banner)
                setShowContactBanner(true)
            }
        }
    }

    const openContact = () => {
        navigate('/account', {replace:true, state:{activeModule:'contact'}})
    }

    const openHome = () => {
        navigate('/', {replace:true})
    }


    useEffect(()=>{
        if(props.showPending)
            loadPendingUserExams()
        else
            if(props.showHistory)
                loadHistoryExams(true)
            else
                loadExams(true)
        if(appInfo.is_ofa && !props.showHistory){
            checkHistoryExams()
            checkOfaUserGroups()
        }
        // eslint-disable-next-line
    },[])

    useEffect(()=>{
        checkOfaUserGroups()
        // eslint-disable-next-line
    },[historyExams, appInfo])

    return(
        <>
            {
                props.title && examsData?.length !== 0 ?
                    <TitleH3 className="mb-3">{props.title}</TitleH3>
                : null
            }
            {examsData?.length === 0 && !isLoading && props.showStarted ?
                <div className="mt-5 pt-5 px-2">
                    { props.showHistory ? 
                        <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                            <img src={history_img} className="mb-2" style={{width:'48px'}} alt=""/>
                            <TitleH3 className="text-center">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.no_exam_completed : t.exams.no_exam_completed}</TitleH3>
                            <Text className="text-center mt-2">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.no_exam_completed_text : t.exams.no_exam_completed_text}</Text>
                        </div>
                    :
                    <>
                        {(!appInfo.is_ofa && !appInfo?.personalizations?.tenant_settings?.is_self_assessment) ? 
                            <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                <img src={exam_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                <TitleH3 className="text-center">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.no_exam_available : t.exams.no_exam_available}</TitleH3>
                                <Text className="text-center mt-2">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.no_exam_available_text : t.exams.no_exam_available_text}</Text>
                            </div> :
                        <>
                            {
                                showExamBanner ?
                                    <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                        <img src={exam_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                        <TitleH3 className="text-center">{t.ofa.exam.not_available}</TitleH3>
                                        <Text className="text-center mt-2">{t.ofa.exam.not_available_text}</Text>
                                        <Button onClick={openHome}>{t.buttons.keep_training}</Button>
                                    </div>
                                : <>
                                    {hasPassedExams ?
                                        <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                            <img src={hands_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                            <TitleH3 className="text-center">{t.ofa.exam.passed}</TitleH3>
                                            <Text className="text-center mt-2">{t.ofa.exam.passed_text}</Text>
                                        </div> :
                                        <>
                                            { !appInfo?.personalizations?.ofa_settings?.esse3_integration_enabled && showContactBanner &&
                                                <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                                    <img src={question_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                                    <TitleH3 className="text-center">{t.ofa.exam.not_passed}</TitleH3>
                                                    <Text className="text-center mt-2">{t.ofa.exam.not_passed_text}</Text>
                                                    <Button onClick={openContact}>{t.ofa.exam.not_passed_cta}</Button>
                                                </div>
                                            }
                                            { (appInfo?.personalizations?.ofa_settings?.esse3_integration_enabled && showEsse3Banner) &&
                                                <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                                    <img src={question_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                                    <TitleH3 className="text-center">{t.ofa.esse3.not_passed}</TitleH3>
                                                    <Text className="text-center mt-2">{t.ofa.esse3.not_passed_text}</Text>
                                                    <div className="text-center">
                                                            <Button className="mx-auto" onClick={checkEsse3Tests}>{t.ofa.esse3.not_passed_cta}</Button>
                                                            <Button color="secondary" className="mx-auto mt-3" onClick={openContact}>{t.ofa.esse3.contact}</Button>
                                                    </div>
                                                   <small className="mt-3 p-3 border ">
                                                        Per iscriverti alle prove nella tua area privata di <u>studiare.unife.it</u> segui questi passaggi:<br />

                                                        1. Nel menù seleziona "Area Studente" e quindi seleziona "Test di Orientamento".<br />

                                                        2. Nell'elenco "Lista concorsi di valutazione" seleziona: "Test di Valutazione delle Conoscenze Iniziali e Percorsi di Recupero OFA (Obblighi Formativi Aggiuntivi) tramite piattaforma thefaculty" o una delle prove successive.<br />

                                                        3. Segui la procedura di iscrizione al Concorso fino al termine.<br />
                                                    </small>
                                                </div>
                                            } 
                                            { (appInfo?.personalizations?.ofa_settings?.esse3_integration_enabled 
                                                && !showEsse3Banner && appInfo?.is_ofa) &&
                                                <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                                    <img src={question_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                                    <TitleH3 className="text-center">{t.ofa.no_ofa}</TitleH3>
                                                    <Text className="text-center mt-2">{t.ofa.no_ofa_text}</Text>
                                                    <div className="d-flex">
                                                            <Button className="ms-2" onClick={openContact}>{t.ofa.esse3.contact}</Button>
                                                    </div>
                                                </div>
                                            } 
                                            { (appInfo?.personalizations?.ofa_settings?.esse3_integration_enabled 
                                                && !showEsse3Banner && appInfo?.personalizations?.tenant_settings?.is_self_assessment) &&
                                                <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                                    <img src={question_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                                    <TitleH2>{t.ofa.esse3.not_available}</TitleH2>
                                                    <TitleH3 className="text-center">{t.ofa.esse3.verify_test_signup}</TitleH3>
                                                    <small className="mt-2 p-3 border ">
                                                        Iscriviti al Test di valutazione accendendo alla tua area privata di <u>studiare.unife.it</u> e seguendo questi passaggi:<br />

                                                        1. Nel menù seleziona "Area Studente" e quindi seleziona "Test di Orientamento".<br />

                                                        2. Nell'elenco "Lista concorsi di valutazione" seleziona: "Test di Valutazione delle Conoscenze Iniziali e Percorsi di Recupero OFA (Obblighi Formativi Aggiuntivi) tramite piattaforma thefaculty".<br />

                                                        3. Segui la procedura di iscrizione al Concorso fino al termine.<br />

                                                        4. Dopo aver completato l'iscrizione accedi al percorso in app dal cellulare per il test e clicca sul pulsante accedi al test in alto a destra nel percorso<br />
                                                    </small>
                                                    <Text className="text-center mt-2">Se hai ancora bisogno di aiuto contattaci!</Text>
                                                    <div className="d-flex">
                                                            <Button className="ms-2" onClick={openContact}>{t.ofa.esse3.contact}</Button>
                                                    </div>
                                                   
                                                </div>
                                            } 
                                            { (!appInfo?.personalizations?.ofa_settings?.esse3_integration_enabled 
                                                && !showEsse3Banner && appInfo?.personalizations?.tenant_settings?.is_self_assessment) &&
                                                <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                                                    <img src={exam_img} className="mb-2" style={{width:'48px'}} alt=""/>
                                                    <TitleH3 className="text-center">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.no_exam_available : t.exams.no_exam_available}</TitleH3>
                                                    <Text className="text-center mt-2">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.no_exam_available_text : t.exams.no_exam_available_text}</Text>
                                                </div>
                                            } 
                                        </>
                                    }
                                </>
                            }
                        </>}
                    </>
                    }
                </div>
            : null}
            <div className="exams_list">
                {examsData?.map((e,i)=>{
                    if(props.showHistory)
                        return <HistoryExamCard t={t} e={e} key={i} selectExamHistory={setResultsModalData}/>
                    else
                        return <ExamCard t={t} e={e} key={i} showStarted={props.showStarted} />
                })}
                {isLoading && Array.from(Array(3), (v,i)=> <ExamCard key={i}/>)}
            </div>

            {!isLoading && hasMore && examsData?.length > 0 ?
                <div className="d-flex justify-content-center mt-4">
                    <Button color="secondary" onClick={loadMore} disabled={isLoadingMore}>
                        {t.buttons.load_more}
                    </Button>
                </div>
            : null}

            <ExamResultsModal show={resultsModalData !== null} examData={resultsModalData} handleClose={()=>setResultsModalData(null)} />

            {
                appInfo.is_ofa && props.showHistory && examsData?.length !== 0 ?
                    <small className="mt-5 text-center d-block">Se hai superato le prove di verifica finali, i certificati ti sono stati inviati via mail e l'esito verrà comunicato alla segreteria nei prossimi giorni.</small> : ""
            }
        </>
    )
}

function ExamCard ({t, e = null,i = null, showStarted=true}) {

    const navigate = useNavigate()

    const openExam = () => {
        if(showStarted)
            navigate(`/exams/preview/${e?.exam_id}`, {replace:true, state:{exam: e}})
    }

    return(
        <div className="exam_card pointer" onClick={openExam} >
            {
                (e?.is_started && e?.state !== 'starting') ?
                <div className="exam_card_label">
                    <img className="align-middle me-1" src={img_clock} />
                    <span>{t.exam.in_progress}</span>
                </div> : null
            }
            <div className="exam_card_content">
                <div className="d-flex justify-content-between align-items-center">
                    <TitleH3>{e?.title || e?.exam_title}</TitleH3>
                    {e?.exam_id && showStarted ?
                    <Link to={`/exams/preview/${e?.exam_id}`} state={{exam: e}} >
                        <img src={img_arrow} alt="" />
                    </Link> : null}
                </div>
                {e?.is_customizable ?
                    <span className="exam_customizable_badge mb-2">
                        <img src={structure_img} alt="" />
                        {t.exams.customizable_label}
                    </span>
                : null}
                <Text>{e?.description || <Skeleton count={3}/>}</Text>
                {e?.exam_id ?
                    <div className="d-flex justify-content-between align-items-center">
                        {
                            showStarted && (e?.end_date || e?.exam_end_date) ?
                                <span style={{fontSize:"12px",fontWeight:"500",color:"#6D6F73"}}>{t.exams.up_to} {new Date(e?.end_date || e?.exam_end_date).toLocaleDateString()}</span>
                            : <span>
                                {e?.start_date ?
                                    <span style={{fontSize:"12px",fontWeight:"500",color:"#6D6F73"}}>{t.exams.from} {new Date(e?.start_date).toLocaleDateString()}</span>
                                : null}
                            </span>
                        }
                        {
                            e?.allowed_all ?
                                <img src={img_users} alt="" /> :
                            <img src={img_user} alt="" />
                        }
                    </div>
                : ""}
                </div>
        </div>
    )
}

function HistoryExamCard ({t, e = null,i = null, selectExamHistory}) {

    const renderTotalTime = () => {
        let total = 0
        e?.user_modules?.forEach(m=> {
            total += m.consumed_time
        });
        return total
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
    Prova in revisione dal proctor.
Il Test è stato inviato correttamente, terminata la revisione, l’esito sarà comunicato all’Università.        </Tooltip>
      );
    
    return(
        <div className="exam_card pointer" >
            {
                e?.state === 'review_needed' ?
                <div className="exam_card_label d-flex justify-content-between align-items-center px-2">
                    <span>{t.exam.in_review}</span>
                    <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                    >
                        <img src={info_img} />
                    </OverlayTrigger>
                </div> : null
            }
            {
                e?.state === 'correction_in_progress' ?
                <div className="exam_card_label d-flex justify-content-between align-items-center px-2">
                    <span>{t.exam.correction_in_progress}</span>
                </div> : null
            }
            <div className="exam_card_content">
                <div className="d-flex justify-content-between">
                    <div className="exam_score">
                        <img src={timer_img} alt="" style={{maxWidth:'20px', verticalAlign:'sub'}}/>
                        <span>
                            {renderTotalTime()} min
                        </span>
                    </div>
                    <div className="exam_score">
                        <span>
                            {new Date(e?.end_date).toLocaleDateString()}
                        </span>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                     <TitleH3 className="mt-2">{e?.title || e?.exam_title}</TitleH3>
                </div>
                {e?.is_customizable ?
                    <div className="d-flex justify-content-center mt-1">
                        <span className="exam_customizable_badge">
                            <img src={structure_img} alt="" />
                            {t.exams.customizable_label}
                        </span>
                    </div>
                : null}
                <div className="exam_score d-flex justify-content-center aling-items-center mt-2">
                    <img src={score_img} alt="" className="me-2"/>
                    <span>
                        <strong>{formatScore(e?.total_score)}</strong> {t.exam.points}
                    </span>
                </div>
                <div className="d-flex justify-content-around aling-items-center">
                    { e?.visible_questions_review ?
                    <div className="d-flex aling-items-center mt-2">
                        <img src={details_img} alt="" className="me-1"/>
                        <Link to={`/exams/review/${e?.user_exam_id}`}>
                            <u>{t.exam.questions}</u>
                        </Link>
                    </div> : null }
                    { e?.is_self_assessment_test ?
                    <div className="d-flex aling-items-center mt-2">
                        <img src={details_img} alt="" className="me-1"/>
                        <Link to={`/exams/exam_detailed_results/${e?.user_exam_id}`}>
                            <u>{t.exam.details}</u>
                        </Link>
                    </div> : null }
                    { e?.visible_scoreboard ?
                    <div className="d-flex aling-items-center mt-2">
                        <img src={rank_img} alt="" className="me-1"/>
                        <Link to={`/exams/scoreboard/${e.exam_id}`}>
                            <u>{t.exam.rank}</u>
                        </Link>
                    </div> : null}
                    { (!e?.is_self_assessment_test && e?.certificate_pdf_url) ?
                    <div className="d-flex aling-items-center mt-2">
                        <img src={details_img} alt="" className="me-1"/>
                        <a href={e?.certificate_pdf_url || ''} target="_blank">
                            <u>{t.exam.certificate}</u>
                        </a>
                    </div> : null}
                    { ( e?.thresholds?.find(t => t?.is_showable)) ?
                    <div className="d-flex aling-items-center mt-2">
                        <img src={point_img} alt="" className="me-1"/>
                        <a href='#' onClick={()=>selectExamHistory(e)}>
                            <u>{t.exam.points_results}</u>
                        </a>
                    </div> : null}
                </div>
            </div>
        </div>
    )
}